import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { AuthService, CmsService, Page, ProductSearchService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as $ from 'jquery';
import { combineLatest, Observable, of, Subscription, switchMap } from 'rxjs';
import { EmailPopupComponent } from './shared/modules/email-popup/email-popup/email-popup.component';
import { ExternalsiteAlertComponent } from './shared/modules/externalsite-alert/externalsite-alert/externalsite-alert.component';
import { SharedService } from './shared/services/shared.service';
import { B2bUserService } from './shared/services/b2b-user.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { MakeAPaymentService } from './custom-make-a-payment/make-a-payment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly b2bUserService = inject(B2bUserService);
  private readonly makePaymentService = inject(MakeAPaymentService);
  private readonly searchService = inject(ProductSearchService);
  title = 'ssspartacusstore';
  eventReference: any;
  isUserLoggedIn = false;
  pageName: string;
  pageId: string;
  modalOption: NgbModalOptions = {};
  emailConsent: any;
  userId: any;
  accountId: any;
  isAsmEnabled: any;
  isLoggedIn: Observable<boolean>;
  emailConsentEnabled: boolean;
  isSSOEnabled = false;
  asmSub: Subscription;
  private $b2bUnit: Observable<any>;
  private isLoggedInUser: boolean;
  constructor(
    private readonly renderer: Renderer2,
    private readonly pageDate: CmsService,
    private readonly authService: AuthService,
    private readonly sharedService: SharedService,
    private readonly router: RoutingService,
    private readonly route: Router,
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly _renderer2: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.$b2bUnit = toObservable(this.b2bUserService.b2bUser);
    this.isLoggedIn = this.authService.isUserLoggedIn();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res) => {
      if (res.hasOwnProperty('asm')) {
        this.isSSOEnabled = true;
        this.sharedService.setLocalStorage('ssoEnabled', this.isSSOEnabled);
      }
    });
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        window.scrollTo(0, 0);
      }
    });
    this.csAgentAuthService
      .isCustomerSupportAgentLoggedIn()
      .subscribe((agentLoggedIn) => {
        if (agentLoggedIn) {
          this.document.querySelector('body').classList.add('agent-logged-in');
        } else {
          this.document
            .querySelector('body')
            .classList.remove('agent-logged-in');
        }
      });
    this.addSnippet();

    combineLatest([
      this.pageDate.getCurrentPage(),
      this.isLoggedIn,
      this.csAgentAuthService.isCustomerEmulated(),
      this.user.get()
    ])
      .pipe(
        switchMap(([currentPage, isLoggedIn, isEmulated, user]: [Page, boolean, boolean, any]) => {
          this.pageName = currentPage?.name;
          this.pageId = currentPage?.pageId;
          this.isAsmEnabled = isEmulated || false;
          this.isLoggedInUser = isLoggedIn;

          this.onUserEmulated(isEmulated);
          this.isSSOEnabled = this.sharedService.getLocalStorage('ssoEnabled');

          if (user?.userName !== this.userId) {
            this.setupUser(user);
          }

          if (user) {
            return this.b2bUserService.b2bUser() ? this.$b2bUnit : this.b2bUserService.getB2BUserById(user?.userName);
          }

         return of(null);
        })
      )
      .subscribe(b2bUser => {
        this.setupRedirections(this.isLoggedInUser, b2bUser);
    });

    this.renderer.listen('document', 'click', (event) => {
      if (event.target.parentElement?.parentElement?.parentElement?.parentElement?.classList.contains('app-navigation-links')) {
        event.preventDefault();
        event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('external');
        if (event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('external')) {
          const modalRef = this.modalService.open(ExternalsiteAlertComponent, {
            windowClass: 'externalsite-modal',
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.componentInstance.eventReference =
            event.target.parentElement.parentElement.href;
        } else {
          window.open(event.target.parentElement.parentElement.href);
        }
      }

      if (event.target.classList.contains('app-navigation-links') || event.target.parentElement?.parentElement?.classList.contains('app-navigation-links')) {
        let type;
        if (event.target.nodeName == 'IMG') {
          type = event.target.parentElement.parentElement.type;
          this.eventReference = event.target.parentElement.parentElement.rel;
        } else {
          event.preventDefault();
          type = event.target.type;
          this.eventReference = event.target.rel;
        }
        if (type === 'external') {
          const modalRef = this.modalService.open(ExternalsiteAlertComponent, {
            windowClass: 'externalsite-modal',
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.componentInstance.eventReference = this.eventReference;
        } else if (type === 'internal') {
          window.open(this.eventReference);
        }
      }

      $('.SiteLinks').find('a').addClass('login-link');
      if (event.target.classList.contains('close-banner')) {
        const elementArray = document.getElementsByClassName('Section1');
        const displayBanner = document.getElementsByClassName(
          'ContentSlotHeaderBannerOrdersListing'
        );
        const accImpBanner = document.getElementsByClassName(
          'SanofiAccountOverviewBannerSlot'
        );
        const plpBanner = document.getElementsByClassName(
          'SanofiProductListingBannerSlot'
        );
        const searchBanner = document.getElementsByClassName(
          'SanofiProductSearchBannerSlot'
        );
        for (let item = 0; item < elementArray.length; item++) {
          elementArray[item].className += ' bannerHide';
        }
        for (let item = 0; item < displayBanner.length; item++) {
          displayBanner[item].className += ' bannerHide';
        }
        for (let item = 0; item < accImpBanner?.length; item++) {
          accImpBanner[item].className += ' bannerHide';
        }
        for (let item = 0; item < plpBanner?.length; item++) {
          plpBanner[item].className += ' bannerHide';
        }
        for (let item = 0; item < searchBanner?.length; item++) {
          searchBanner[item].className += ' bannerHide';
        }
      }

      const hamburger = document.getElementsByClassName('cx-hamburger');
      const hideSiteContext = document.getElementsByClassName('SiteContext');
      const hideSiteLink = document.getElementsByClassName('SiteLinks');
      const hideSearchBox = document.getElementsByClassName('SearchBox');
      const hideSiteLogo = document.getElementsByClassName('SiteLogo');
      const hideMiniCart = document.getElementsByClassName('MiniCart');
      const hideSiteLogin = document.getElementsByClassName('SiteLogin');
      let expandedOption;
      for (let i = 0; i < hamburger.length; i++) {
        expandedOption = hamburger[i].classList.contains('is-active');
      }
      if (expandedOption) {
        for (let i = 0; i < hideSiteContext.length; i++) {
          hideSiteContext[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLink.length; i++) {
          hideSiteLink[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSearchBox.length; i++) {
          hideSearchBox[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLogo.length; i++) {
          hideSiteLogo[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideMiniCart.length; i++) {
          hideMiniCart[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLogin.length; i++) {
          hideSiteLogin[i].classList.add('noDisplay');
        }
      } else {
        for (let i = 0; i < hideSiteContext.length; i++) {
          hideSiteContext[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLink.length; i++) {
          hideSiteLink[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSearchBox.length; i++) {
          hideSearchBox[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLogo.length; i++) {
          hideSiteLogo[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideMiniCart.length; i++) {
          hideMiniCart[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLogin.length; i++) {
          hideSiteLogin[i].classList.remove('noDisplay');
        }
      }
    });
  }
  emailConsentContent() {
    if (!sessionStorage.getItem('emailPopUp')) {
      this.sharedService.getEmailConsent(this.userId);
      this.emailConsentEnabled = true;
      this.sharedService.emailConsent$.subscribe((result) => {
        if (result) {
          if (
            !this.modalService.hasOpenModals() &&
            result.emailConsentEnabled === true
          ) {
            this.modalOption.backdrop = 'static';
            this.modalOption.keyboard = false;
            this.modalOption.windowClass = 'email-popup-modal';
            const modalRef = this.modalService.open(
              EmailPopupComponent,
              this.modalOption
            );
            modalRef.componentInstance.emailConsentObj = result;
            modalRef.componentInstance.userId = this.userId;
            sessionStorage.setItem('emailPopUp', 'true');
            this.sharedService.emailConsent.next(false);
          }
        }
      });
    }
  }
  addSnippet() {
    this.sharedService.getsnippetAPI();
    this.sharedService.snippetData$.subscribe((result) => {
      if (result.snippetConfigs && result.snippetConfigs.length > 0) {
        let snippetCommentStart = this._renderer2.createComment(
          'BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET'
        );
        let snippetCommentEnd = this._renderer2.createComment(
          'END WEBSITE FEEDBACK SNIPPET'
        );
        for (const config of result.snippetConfigs) {
          const snippetValue = config.value.replace(/\\n/g, '');
          let script = this._renderer2.createElement('script');
          script.type = `text/javascript`;
          script.text = snippetValue;
          this._renderer2.appendChild(this.document.head, snippetCommentStart);
          this._renderer2.appendChild(this.document.head, script);
          let snippetDiv = this._renderer2.createElement('div');
          snippetDiv.id = config.divId;
          let snippetDivComment = this._renderer2.createComment(
            'DO NOT REMOVE-CONTENTS PLACED HERE'
          );
          snippetDiv.appendChild(snippetDivComment);
          this._renderer2.appendChild(this.document.head, snippetDiv);
          this._renderer2.appendChild(this.document.head, snippetCommentEnd);
        }
      }
    });
  }

  private setupUser(user: any) {
    if (user === undefined) {
      this.searchService.clearResults();
      this.isUserLoggedIn = false;
      this.emailConsentEnabled = false;
      this.userId = undefined;
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_type');
      localStorage.removeItem('user_function');
      localStorage.removeItem('user_account_id');
      localStorage.removeItem('user_login_id');
      sessionStorage.removeItem('sessionCartPopover');
      sessionStorage.removeItem('restored_cart');
      localStorage.removeItem('asmUserId');
      localStorage.removeItem('isShowFlag');
      localStorage.removeItem('paymentConfirmation');
      sessionStorage.removeItem('paymentConfirmation');
      sessionStorage.removeItem('invoicesData');
      sessionStorage.removeItem('creditData');
      this.b2bUserService.resetUser();
      this.makePaymentService.clearCachedInvoices();
      this.makePaymentService.clearCachedCredits();
    } else {
      const qresult: any = user;
      this.emailConsent = qresult?.emailConsent;
      this.userId = qresult?.userName;
      this.isUserLoggedIn = true;
      this.accountId = qresult?.orgUnit?.uid;
      localStorage.setItem('asmUserId', user?.uid);
      localStorage.setItem('user_id', qresult?.janrainId);
      localStorage.setItem('user_type', 'Internal customer');
      localStorage.setItem('user_function', qresult?.role);
      localStorage.setItem('user_login_id', this.userId);
      localStorage.setItem('user_account_id', this.accountId);
      setTimeout(() => {
        const sessionCart = sessionStorage.getItem('sessionCartPopover');
        if (sessionCart && sessionCart != null) {
          sessionStorage.setItem('restored_cart', 'true');
        } else {
          sessionStorage.setItem('restored_cart', 'false');
        }
      }, 1000);
    }
    this.cdr.detectChanges();
  }

  private onUserEmulated(isEmulated: boolean): void {
    if (localStorage.getItem('asmEnabled') == 'false' && isEmulated) {
      window.location.reload();
    }
    this.sharedService.setLocalStorage('asmEnabled', isEmulated);

    if (isEmulated) {
      this.document
        .querySelector('body')
        .classList.add('session-running');
    } else {
      this.document
        .querySelector('body')
        .classList.remove('session-running');
    }


    if (!this.isAsmEnabled && !(this.pageId === 'customerDetails' || this.pageId === 'userManagement')) {
      sessionStorage.removeItem('filterAttributes');
      sessionStorage.removeItem('b2BUnitNameFilter');
      sessionStorage.removeItem('b2BUnitFilter');
      sessionStorage.removeItem('emailFilter');
      sessionStorage.removeItem('cusNameFilter');
      sessionStorage.removeItem('userNameFilter');
      sessionStorage.removeItem('pageSizeperPage');
    }
  }

  private setupRedirections(isLoggedIn: boolean, b2bUser: any): void {
    if (!isLoggedIn || !b2bUser) {
      sessionStorage.removeItem('userAccountId');

      return;
    }

    if (b2bUser?.payerCustomerFlag === true && this.pageName === 'Homepage') {
      this.router.goByUrl('my-account/make-payment');
      return;
    }
    if (this.pageName === 'Homepage' || this.pageId === 'LoginPageReference' || this.pageId === 'Login Page') {
      this.router.goByUrl('Open-Catalogue/c/1');
    }
  }
}
